export enum CullFace {
    FRONT = 0,
    BACK = 1,
    DISABLED
}
